import {ReportDefinitionLine} from '../domain/reportdefinitionline'
import { IdName } from './idname';

export class ReportDefinition {
    Id : number;
    ReportType: IdName;
    CompanyId : number;
    Name : string;
    ReportPreviewLink: string;
    Description : string;
    DimensionId1 : any;
    Dimension1 : string;
    DimensionId2 : any;
    Dimension2 : string;
    DimensionId3 : any;
    Dimension3 : string;
    DimensionId4 : any;
    Dimension4 : string;
    lines: Array<ReportDefinitionLine>;
    Filter: IdName[];
}
